module.exports = __webpack_public_path__ + "funnel.c35e1f6a013f0c8f881052f5534daae1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/funnel.svg
// module id = 1140
// module chunks = 0